// @core/api/endpoints/platform/list_platform_products.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPlatformProductsResponse,
} from '../../../types/platform';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/platform';

/**
 * List products on platform
 * Returns all products configured for the platform with their availability status, branding, and configuration. Public endpoint for product catalog display.
 * @public This endpoint does not require authentication
 */
export async function ListPlatformProducts(
  platform_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPlatformProductsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/products`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ListPlatformProductsResponse>(requestPath, { ...requestOptions, params });
}
